ACC.myShoppingList = {

  addProductLayout: function() {
    $('.ph-add-product-div').remove();

    var productCt = $('.sticky-compare-bar .compare-products li').length;

    if (productCt < 4) {
      for (var k = productCt; k < 4; k = k + 1) {
        $('.compare-products').append('<div class="ph-add-product-div ph-prodCmpare">' + $('.ph-compareaddproducts').html() + '</div>');
      }
    }
  },
  shoppingListBind: function(popupContainer) {
    var allfavListWrap = '';

    if ($('.ph-addtoshoppinglist-container:first .ph-addtoshoppinglist li').length !== $(popupContainer).find('.ph-addtoshoppinglist li').length) {
      $('.ph-addtoshoppinglist-container:first .ph-addtoshoppinglist li').each(function() {
        if (typeof $(this).attr('data-listname') !== 'undefined') {
          allfavListWrap = allfavListWrap + $(this)[0].outerHTML;
        }
      });
      allfavListWrap = allfavListWrap + $(popupContainer).find('.ph-newlist-row')[0].outerHTML;
      $(popupContainer).find('.ph-addtoshoppinglist').html(allfavListWrap);
    }
  },
  addToShoppingList: function() {
    $(document).on('click', '.ph-prod-addtoshoppinglist', function() {
      var popupContainer = '#addtoshoppinglist-container-' + $(this).attr('data-productcode'),
          $currentNode = $(this),
          $formClass = $currentNode.parents('.add_to_cart_form');

      if ($currentNode.hasClass('ph-pdp_hearticon_addtolist')) {
        $formClass = $('.ph-pdp_buttons_section');
      }

      ACC.myShoppingList.shoppingListBind(popupContainer);

      $.colorbox({
        html: $(popupContainer).html(),
        width: '90%',
        maxWidth: 750,
        top: 50,
        minHeight: 300,
        height: '70%',
        close: '<button type=\'button\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
        onComplete: function() {
          ACC.common.refreshScreenReaderBuffer();
          $formClass.addClass('savelistpopup');
        },
        onClosed: function() {
          ACC.myShoppingList.showHideNewlistValidationMsg(false);
          ACC.common.refreshScreenReaderBuffer();
          $formClass.removeClass('savelistpopup');
        }
      });
    });

    $(document).on('click', '.ph-newlistinputcheck', function() {
      $('#cboxContent').find('.ph-savetolistBtn, .ph-cart-savetolistBtn').removeClass('ph-disabledbutton');
      $('#cboxContent .ph-newlistfield_removedisable').removeAttr('disabled');
      $('#cboxContent .ph-newlistcreation_field').removeClass('ph-d-none');
      $('#cboxContent .ph-newlistcreation_field').addClass('ph-d-block');
    });

    $(document).on('click', '.ph-savetolistBtn', function() {
      var productCode = $(this).attr('data-productcode');
      var rdoElId = '#cboxLoadedContent #ph-shoppinglistRdo-' + productCode;
      var $selRdoEl = $(document).find(rdoElId + ':checked');

      if ($selRdoEl.length > 0) {
        var listName = $selRdoEl.val();

        if (listName === 'newList') {
          var $inputEl = $('#cboxContent #ph-newList-' + productCode);

          listName = $inputEl.val();

          if (listName.trim() === '') {
            ACC.myShoppingList.showHideNewlistValidationMsg(true);
            $inputEl.focus();

            return;
          }

          ACC.myShoppingList.showHideNewlistValidationMsg(false);
        }

        ACC.myShoppingList.addProductToList(listName, productCode, function(result) {
          var isAlreadyExists = false;
          var listNumber = 0;
          var length = $('#cboxLoadedContent .ph-addtoshoppinglist li').length;

          for (listNumber = 0; listNumber < length - 1; listNumber = listNumber + 1) {
            var listNameIt = $('#cboxLoadedContent .ph-addtoshoppinglist #ph-existingList-' + listNumber).attr('data-listName');

            if (result.orderName.toLowerCase() === listNameIt.toLowerCase()) {
              isAlreadyExists = true;

              break;
            }
          }

          ACC.myShoppingList.updateShoppingList(isAlreadyExists, false, result, listNumber);
          $.colorbox.close();
        });
      }
    });

    $(document).on('click', '#ph-cart-savetolistBtn', function() {
      var listName = $('#cboxContent #ph-newList-cart').val(),
          rdoElId = '.ph-shoppinglistRdo',
          $selRdoEl = $(rdoElId + ':checked');

      if ($selRdoEl.length > 0) {
        listName = $selRdoEl.val();
      }

      if (listName.trim() === '') {
        $(document).find('.ph-newlistinputcheck').trigger('click');
        ACC.myShoppingList.showHideNewlistValidationMsg(true);
        $(document).find('.ph-newList-cart').focus();

        return;
      }

      ACC.myShoppingList.showHideNewlistValidationMsg(false);
      ACC.myShoppingList.addCartItemsToShoppingList(listName, function(result) {
        var isAlreadyExists = false;
        var listNumber = 0;
        var length = $('#cboxLoadedContent .ph-addtoshoppinglist li').length;

        for (listNumber = 0; listNumber < length - 1; listNumber = listNumber + 1) {
          var listNameIt = $('#cboxLoadedContent .ph-addtoshoppinglist #ph-existingList-' + listNumber).attr('data-listName');

          if (result.orderName.toLowerCase() === listNameIt.toLowerCase()) {
            isAlreadyExists = true;

            break;
          }
        }

        var savelistMsg = $('.newsavelistMsg').html() + ' "' + result.orderName + '"',
            messageTypeClass = 'ph-info_neutral';

        $('.ph-customglobalmsg .ph-information_message').removeClass('ph-info_neutral ph-info_negative');

        if (result.errorMessage) {
          messageTypeClass = 'ph-info_negative';
          savelistMsg = result.errorMessage;
        }

        $('.ph-customglobalmsg .ph-information_message')
          .removeClass('hidden hiddenClass')
          .addClass(messageTypeClass)
          .find('.ph-customglobal_message').html(savelistMsg);
        ACC.myShoppingList.updateShoppingList(isAlreadyExists, true, result, listNumber);
        $.colorbox.close();
      });
    });

    $(document).on('click', '#ph-shopping-rdo-btn', function() {
      var listName = $(this).parent().find('input').val();
      var productCode = $(this).parents('.ph-addtoshoppinglist').attr('data-productcode');
      var $inputEl = $('#ph-newList-' + productCode);

      if (listName === 'newList') {
        $inputEl.removeAttr('disabled');
        $inputEl.focus();
      } else {
        ACC.myShoppingList.showHideNewlistValidationMsg(false);
        $inputEl.val('');
        $inputEl.attr('disabled', 'disabled');
        $('#cboxContent .ph-newlistcreation_field').removeClass('ph-d-block');
        $('#cboxContent .ph-newlistcreation_field').addClass('ph-d-none');
      }

      $('#cboxContent').find('.ph-savetolistBtn').removeClass('ph-disabledbutton');
    });

    $(document).on('click', '#ph-cart-shopping-rdo-btn', function() {
      var listName = $(this).parent().find('input').val();
      var $inputEl = $('#ph-newList-cart');

      if (listName === 'newList') {
        $inputEl.removeAttr('disabled');
        setTimeout(function() {
          $inputEl.focus();
        }, 0);
      } else {
        ACC.myShoppingList.showHideNewlistValidationMsg(false);
        $inputEl.val('');
        $inputEl.attr('disabled', 'disabled');
        $('#cboxContent .ph-newlistcreation_field').removeClass('ph-d-block');
        $('#cboxContent .ph-newlistcreation_field').addClass('ph-d-none');
      }

      $('#cboxContent').find('.ph-cart-savetolistBtn').removeClass('ph-disabledbutton');
    });

    $(document).on('click', '.ph-addtoshoppinglist .ph-listname', function() {
      $(this).parent().find('.ph-checkmark').trigger('click');
      $(this).parent().find('.ph-shoppinglistRdo').trigger('click');
    });

    $(document).on('click', '.ph-btn-cont .ph-addtolist-cancel', function() {
      $.colorbox.close();
    });

    $('.clear-list').click(function() {
      $('.createnewlist-txt').val('');
    });

    if ($('.addtoshoppinglist li').length > 8) {
      $('ul.addtoshoppinglist').addClass('mCustomScrollbar');
    }
  },

  showHideNewlistValidationMsg: function(isShow) {
    var $parentEl = $('.ph-createnewlist-txt');

    if (isShow === true) {
      $parentEl.find('input').addClass('ph-error-border');
      $parentEl.find('.ph-exclamation-mark').show();
      $parentEl.find('.ph-newlist-empty-validation').show('');
    } else {
      $parentEl.find('input').removeClass('ph-error-border');
      $parentEl.find('.ph-exclamation-mark').hide();
      $parentEl.find('.ph-newlist-empty-validation').hide('');
    }
  },

  addProductToList: function(listName, productCode, successCallback) {
    var productQty = 1;

    if ($(document).find('.savelistpopup').length > 0) {
      productQty = parseInt($(document).find('.savelistpopup .qty').val(), 10);

      if (!productQty > 0) {
        productQty = 1;
      }
    }

    $.ajax({
      url: ACC.config.contextPath + '/shoppingList/addProductToList',
      data: {
        orderName: listName,
        productCode: productCode,
        productQty: productQty
      },
      type: 'POST',
      datatype: 'json',
      success: function(result) {
        successCallback(result);
      }
    });

    $('#ph-listname_afterradiobtnclick').val(listName);
    $('#product_list_id').text('"' + listName + '"').css({
      position: 'initial',
      display: 'inline-block'
    });
    $('.ph-pdp_addtolistmsg').removeClass('ph-d-none');
  },

  addCartItemsToShoppingList: function(listName, successCallback) {
    var oppIdValue = '';

    if ($('#cboxLoadedContent .ph-oppId').length > 0) {
      oppIdValue = $('#cboxLoadedContent .ph-oppId').val().trim();
    }

    $.ajax({
      url: ACC.config.contextPath + '/shoppingList/addToShoppingList',
      data: {
        favListName: listName,
        opportunityId: oppIdValue
      },
      type: 'POST',
      datatype: 'json',
      success: function(result) {
        successCallback(result);
      }
    });
  },

  updateShoppingList: function(isAlreadyExists, isCartPage, listObj, listNumber) {
    $('.ph-addtoshoppinglist-container').each(function() {
      if (isAlreadyExists) {
        $(this).find('#ph-existingList-' + listNumber).find('#prodCount').text(listObj.orderProductCount);
      } else if (isCartPage === true) {
        $(this).find('.ph-addtoshoppinglist').prepend('<li class = "rl-trim hidden" id="ph-existingList-' + listNumber + '" data-listName = "' + listObj.orderName + '">' +
                    '<label class="ph-radiocontainer ph-float-left">' +
                    '<input type="radio" class="ph-shoppinglistRdo" data-listNumber="' + listNumber + '" id="ph-shoppinglistRdo"  value="' + listObj.orderName + '" name="b2bUnit">' +
                    '<span class="ph-checkmark" id="ph-cart-shopping-rdo-btn"></span>' +
                    '</label>' +
                    '<span class="ph-listname">' + listObj.orderName + ' (<span id="prodCount">' + listObj.orderProductCount + '</span> Products)</span>' +
                    '</li>');
      } else {
        var productCode = $(this).find('.ph-addtoshoppinglist').attr('data-productcode');

        $(this).find('.ph-addtoshoppinglist').prepend('<li class = "rl-trim" id="ph-existingList-' + listNumber + '" data-listName = "' + listObj.orderName + '">' +
                    '<label class="ph-radiocontainer ph-float-left">' +
                    '<input type="radio" class="ph-shoppinglistRdo" data-listNumber="' + listNumber + '" id="ph-shoppinglistRdo-' + productCode + '"  value="' + listObj.orderName + '" name="b2bUnit">' +
                    '<span class="ph-checkmark" id="ph-shopping-rdo-btn"></span>' +
                    '</label>' +
                    '<span class="ph-listname">' + listObj.orderName + ' (<span id="prodCount">' + listObj.orderProductCount + '</span> Products)</span>' +
                    '</li>');
      }
    });
  },

  sliceText: function(origTextArray, textLength, length) {
    var newText = '';

    if (textLength >= length) {
      newText = String(origTextArray.substr(0, length)) + '..';
    }

    return newText;
  },

  createNewListButton: function() {
    $('#createNewListButton').click(function() {
      var listname = $('#newListName').val();

      /* eslint-disable  no-useless-escape */
      listname = listname.replace(/[^a-zA-Z0-9 \-\_]/g, '');
      /* eslint-enable  no-useless-escape */
      listname = listname.replace(/\s{2,}/g, ' ');

      if (listname !== null && listname.trim() !== null && listname.trim() !== '') {
        listname = listname.trim();
        $.ajax({
          url: ACC.config.contextPath + '/shoppingList/addToShoppingList',
          data: {
            favListName: listname
          },
          type: 'POST',
          datatype: 'json',
          success: function(result) {
            var alreadyExists = 0,
                length = $('.addtoshoppinglist li').length,
                i = 0,
                obj = $.parseJSON(JSON.stringify(result));

            for (i = 0; i < length; i = i + 1) {
              var listId = '#shoppingList' + i;
              var list = $(listId).attr('data-listName');

              if (typeof list !== 'undefined' && listname.toLowerCase() === list.toLowerCase()) {
                alreadyExists = 1;
                $('#shoppingListProductcount' + i).text('(' + obj.orderProductCount + ')');

                break;
              }
            }

            $('.ph-addtoshoppinglist-container').toggle();

            if (alreadyExists === 0) {
              var prependList = obj.orderName;

              if (prependList.length > 15) {
                prependList = prependList.substring(0, 15) + '..';
              }

              $('.addtoshoppinglist').prepend('<li><a href=\'javascript:void();\' class=\'shoppingListName\' id=\'shoppingList' + length + '\' data-listName=\'' + obj.orderName + '\'>' + prependList + '</a> <span class=\'addtoshoppinglist-count\'>(' + obj.orderProductCount + ')</span></li>');
            }

            $('.createnewlist-txt').val('');

            setTimeout(function() {
              $('#white_content')
                .fadeOut();
            }, 5000);
          }
        });
      }

      $('#createNewListButton').click(function() {
        $('.addtoshoppinglist li:even').removeClass('sam').removeClass('sams').addClass('sam');
        $('.addtoshoppinglist li:odd').removeClass('sam').removeClass('sams').addClass('sams');
      });
    });
  },

  shoppingListName: function() {
    $('.shoppingListName').click(function() {
      var listname = $(this).attr('data-listName');
      var listNumber = $(this).attr('data-listNumber');

      $.ajax({
        url: ACC.config.contextPath + '/shoppingList/addToShoppingList',
        data: {
          favListName: listname
        },
        type: 'POST',
        datatype: 'json',
        success: function(result) {
          $('.ph-addtoshoppinglist-container').toggle();

          var obj = $.parseJSON(JSON.stringify(result));
          var spanId = 'shoppingListProductcount' + listNumber;

          $('#' + spanId).html('(' + obj.orderProductCount + ')');


        // }
        }
      });
    });
  },
  shoppingListTooltip: function() {
    $(document).on('click', '.ph-saveTolist_icon', function() {
      $('.ph-saveToList_tooltipText').toggleClass('hidden');
    });
  },
  enableButton: function() {
    $(document).on('keyup', '#ph-newList-cart', function() {
      if ($(this).val().length > 0) {
        $('.ph-cart-savetolistBtn').removeClass('ph-disabledbutton');
      } else {
        $('.ph-cart-savetolistBtn').addClass('ph-disabledbutton');
      }
    });
  },
  mylistPopupGeneration: function() {
    $.colorbox({
      html: $('#addtoshoppinglist-container-cart').html(),
      width: '100%',
      maxWidth: 750,
      top: 50,
      height: 'auto',
      maxHeight: '80%',
      close: '<button type=\'button\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
      onComplete: function() {
        ACC.common.refreshScreenReaderBuffer();
      },
      onClosed: function() {
        $('#ph-cart-savetolistBtn').addClass('ph-disabledbutton');
        ACC.myShoppingList.showHideNewlistValidationMsg(false);
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  },
  mylistDynmicData: function() {
    $.get('/cart/getSavedwishList').done(function(dataRespone) {
      var indexNumber = 0,
          listsHtml = '';

      dataRespone.forEach(function(myListItem) {
        var listName = myListItem.shopWishListName,
            productCount = myListItem.shopWishListEntrySize;

        if (listName !== 'Favorites') {
          listsHtml = listsHtml + '<li class = "ph-existingListitems rl-trim" id="ph-existingList-' + indexNumber + '" data-listName = "' + listName + '">';
          listsHtml = listsHtml + '<label class="ph-radiocontainer ph-float-left">';
          listsHtml = listsHtml + '<input type="radio" class="ph-shoppinglistRdo" data-listNumber="' + indexNumber + '" value="' + listName + '" name="favlistRadio">';
          listsHtml = listsHtml + '<span class="ph-checkmark" id="ph-cart-shopping-rdo-btn"></span>';
          listsHtml = listsHtml + '</label>';
          listsHtml = listsHtml + '<span class="ph-listname ph-d-block">' + listName + ' (<span id="prodCount">' + productCount + '</span> Products)</span>';
          listsHtml = listsHtml + '</li>';
        }

        indexNumber = indexNumber + 1;
      });
      $(document).find('.ph-addtoshoppinglist').prepend(listsHtml);
      ACC.myShoppingList.mylistPopupGeneration();
    });
  },
  mylistInit: function() {
    $('#addtoshoppinglist-cart').click(function() {
      $(document).find('.ph-addtoshoppinglist .ph-existingListitems').remove();
      ACC.myShoppingList.mylistDynmicData();
    });
    $('.shoppinglistRdoBtn').each(function() {
      $(this).attr('id', 'ph-shoppinglistRdo-' + $(this).attr('data-id'));
    });
    $('.newListClassName').each(function() {
      $(this).attr('id', 'ph-newList-' + $(this).attr('data-id'));
    });
  }
};

$('document').ready(function() {
  ACC.myShoppingList.addToShoppingList();
  $('.rl-trim').each(function() {
    var actualText = $.trim($(this).find('a').text());
    var slicedText = ACC.myShoppingList.sliceText(actualText, actualText.length, 15);

    $(this).find('a').html(slicedText);
  });

  ACC.myShoppingList.createNewListButton();
  ACC.myShoppingList.shoppingListName();
  ACC.myShoppingList.shoppingListTooltip();
  ACC.myShoppingList.enableButton();
  ACC.myShoppingList.mylistInit();

  $('.createnewlist-txt').attr({
    maxLength: 30
  });
  $('.addtoshoppinglist li:even').removeClass('sam').removeClass('sams').addClass('sam');
  $('.addtoshoppinglist li:odd').removeClass('sam').removeClass('sams').addClass('sams');


  ACC.myShoppingList.addProductLayout();
  $(document).on('submit', '#createNewListForm', function(event) {
    var listname = $('#newListName-shoppingList').val();

    /* eslint-disable  no-useless-escape */
    listname = listname.replace(/[^a-zA-Z0-9 \-\_]/g, '');
    /* eslint-enable  no-useless-escape */
    listname = listname.replace(/\s{2,}/g, ' ');

    listname = $.trim(listname);

    if (!listname) {
      event.preventDefault();
    }
  });

  $('#addListToCartForm').on('keyup keypress keydown', function(e) {
    var code = e.keyCode || e.which;

    if (code === 13) {
      e.preventDefault();

      return false;
    }

    return true;
  });
});
